import {createTheme, responsiveFontSizes} from "@mui/material/styles";
import { deepmerge } from '@mui/utils';
import merge from "lodash/merge";
import {THEMES} from '@/constant/Constant'
import components from "./components";
import {shadows} from "./shadows";
import _mainThemesOptions from "./themeOptions";

const baseOptions = {
  direction: "ltr",
  typography: {
    // fontFamily: "'Montserrat', sans-serif"
    fontFamily: "RedotPay"
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      dialogXS: 420
    }
  }
};

export const createCustomTheme = (settings, paramThemeOptions) => {
  /**
   * settings.theme value is 'light' or 'dark'
   * update settings in contexts/settingsContext.tsx
   */
  let __themeOptions = paramThemeOptions || _mainThemesOptions
  __themeOptions = deepmerge(_mainThemesOptions, (paramThemeOptions || {}))
  let themeOptions
  if (!themeOptions)
    themeOptions = __themeOptions[settings.theme];

  if (!themeOptions) {
    themeOptions = __themeOptions[THEMES.LIGHT];
  }

  const mergedThemeOptions = merge({}, baseOptions, themeOptions, {
    direction: settings.direction
  });

  let theme = createTheme({
    ...mergedThemeOptions,
    typography: {
      // Tell MUI what the font-size on the html element is.
      // htmlFontSize: 10,
    },
    cssVariables: {
      cssVarPrefix: 'rp'
    }
  });

  // theme.shadows = shadows(theme); // set components

  theme.components = components(theme);

  if (settings.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};